
<div class="back_login">

  <div fxLayout="row" fxLayoutAlign="center">

        <div fxFlex="35" fxFlex.xs="90" class="login-card">
    
              <div fxLayout="row" fxLayoutAlign="center" style="margin-top:30px;">

                  <div fxFlex="80">
                    <img class="logo" src="assets/static/login_auslroma1_white.png" />
                  </div>

              </div>

              <div fxLayout="row" fxLayoutAlign="center" style="margin-top:10px;">

                  <div fxFlex="80" fxFlex.xs="100">

                          <form (keyup.enter)="login()">

                              <table fxFlex="100" style="border-spacing: 10px;">
                                <tr>
                                  <td class="login_label"> {{ 'users.user_name' | translate }}  </td>
                                  <td > <input class="login_input" matInput  type="text" [(ngModel)]="user.username" name="username"  required> </td>
                                </tr>
                                <tr style="margin-top: 5px;">
                                  <td  class="login_label"> {{ 'users.password' | translate }}  </td>
                                  <td>  <input class="login_input" matInput type="password" [(ngModel)]="user.password" name="password"  required> </td>
                                </tr>

                                <tr>
                                  <td colspan="2" class="t_right">
                                     <button (click)="login()"> {{ 'users.enter' | translate }} </button>
                                  </td>
                                </tr>

                                <tr>
                                  <td colspan="2" class="t_right">
                                        <span style="color:white; font-size:12px;">Versione:</span>
                                        <select name="mode" size="1" [(ngModel)]="login_type_selected">
                                          <option selected="selected" value="p">Predefinito</option>
                                          <option value="a">Avanzato (Ajax)</option>
                                          <option value="h">Standard (HTML)</option>
                                          <option value="m">Cellulare</option>
                                      </select>
                                  </td>
                                </tr>

                              </table>

                          <div *ngIf="errors">
                              <p class="errv red">{{ error_message | translate }}</p>
                              <ng-container>
                                <span *ngIf="error_detailed_message">
                                    <span (click)="detail_expanded = true" class="pointer linked-inside">{{ 'buttons.read_more' | translate }} &#x25BC;</span>
                                    <br><span class="errv red" *ngIf="detail_expanded == true">{{error_detailed_message | translate }}</span>
                                </span>		    
                              </ng-container>		
                          </div>
                          </form>

                          <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

                  </div>
            </div>

        </div>

    </div>

</div>
